export enum BuiltinTileType {
  Wire = 'Wire',
  DebugTimerStart = 'DebugTimerStart',
  DebugTimerEnd = 'DebugTimerEnd',
  BundleInterface = 'BundleInterface',
  Not = 'Not',
  Diode = 'Diode',
  Delay = 'Delay',
  Lever = 'Lever',
  Button = 'Button',
  Random = 'Random',
  And = 'And',
  Bridge = 'Bridge',
  Clock = 'Clock',
  SingleInterface = 'SingleInterface',
  MultiInterface = 'MultiInterface',
  Structure = 'Structure',
}

/** Stable namespace for source-installed extensions; built-in values remain unchanged. */
export type ExtensionTileType = `extension:${string}/${string}`;
export type TileType = BuiltinTileType | ExtensionTileType;
export const TileType = BuiltinTileType;
